import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import './PendingOrders.scss';
import { FxDateDisplay, FxCurrency, http, formatService, AlertService, general } from '../../fx-core';
import * as _ from 'lodash';
import { Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Drawer } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import ProviderItemOrderDetail from '../ProviderItemOrderDetail/ProviderItemOrderDetail';
import ConfirmDialog from '../../ConfirmDialog/ConfirmDialog';
import { DeliverySlots } from '../../OrderConfirmation/DeliverySlots/DeliverySlots';
import MessageContainer from '../../MessageContainer/MessageContainer';
import { NoRecords } from '../../NoRecords/NoRecords';
import { PickUpSlots } from '../../OrderConfirmation/PickUpSlots/PickUpSlots';


const useStyles = makeStyles((theme) => ({
  root: {
    width: '1400px',
  },
  drawerWidth: {
    [theme.breakpoints.down(599)]: {
      width: '90%'
    },
    [theme.breakpoints.up(600)]: {
      width: '70%'
    },
    [theme.breakpoints.up(1025)]: {
      width: '40%'
    }
  }
}));

const PendingOrders = (props: any) => {
  const classes = useStyles();
  const initialList = [];
  const selOrderDefaultObj = {
    id: 0,
    orderStatusId: 0,
    orderTypeId: 0
  };
  const [orderList, setOrderList] = useState(initialList);
  const [open, setOpen] = useState(false);
  const [orderId, setOrderId] = useState(0);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [message, setMessage] = useState(null);
  const [selectedOrder, setSelectedOrder] = useState(selOrderDefaultObj);
  const [isCancelAction, setIsCancelAction] = useState(false);
  const [deliverySlotsOpen, setDeliverySlotsOpen] = useState(false);
  const[pickupSlotsOpen,setPickUpSlotsOpen] = useState(false);
  const [availableSlots, setAvailableSlots] = useState(initialList);
  const [deliverySlotId, setDeliverySlotId] = useState(0);
  const [openMessage, setOpenMessage] = React.useState(false);

  const toggleDrawerMessage = () => {
    setOpenMessage(!openMessage);
  };

  const getPendingOrders = () => {
    let inputData = {
      id: props.stallId
    }
    let apiOptions: any = {
      url: `order/pendingorders/stall/${inputData.id}`
    };
    http.get(apiOptions).then(res => {
      const result = res.data;
      getPendingOrdersCallback(result);
    })
  };

  const getPendingOrdersCallback = (res) => {
    res = _.slice(res, [0], [5]);
    setOrderList(res);
  }

  const viewOrderDetail = (item: any) => {
    setOpen(true);
    setOrderId(item.id);
  };

  const handleClose = () => {
    setOpen(false);
    setOrderId(0);
  };

  const defaulConfirmDialogStateValues = () => {
    setSelectedOrder(selOrderDefaultObj);
    setMessage(null);
    setConfirmOpen(false);
    if (isCancelAction) {
      setIsCancelAction(false);
    }
    props.loadDashboard();
  };

  const openConfirmDialogByStatus = (item) => {
    let msg = "";
    if (item.orderStatusId === 1) {
      msg = "Do you want to accept the order #" + item.orderIdentifier + "?";
    }
    else if (item.orderStatusId === 2 && item.orderTypeId === 1) {
      msg = "Do you want to ship the order #" + item.orderIdentifier + "?";
    }
    else if (item.orderStatusId === 2 && item.orderTypeId === 2) {
      msg = "Is the order #" + item.orderIdentifier + " ready?";
    }
    else if (item.orderStatusId === 4 || item.orderStatusId === 5) {
      msg = "Do you want to deliver the order #" + item.orderIdentifier + "?";
    }
    setSelectedOrder(item);
    setMessage(msg);
    setConfirmOpen(true);
  };

  const handleDialogClose = () => {
    defaulConfirmDialogStateValues()
  };

  const onConfirmCallback = (action, comments) => {
    if (selectedOrder.orderStatusId === 1) {
      if (action === 'cancel') {
        cancelOrder(comments);
      } else {
        markAsAccepted();
      }
    }
    else if (selectedOrder.orderStatusId === 2) {
      markAsReadyOrShipped();
    }
    else if (selectedOrder.orderStatusId === 4 || selectedOrder.orderStatusId === 5) {
      markOrderDelivered();
    }
  };

  const markAsAccepted = () => {
    let apiOptions = {
      url: `order/${selectedOrder.id}/markAsAccepted`
    };
    http.put(apiOptions).then(res => {
      markAsAcceptedCallBack(res);
    });
  };

  const markAsAcceptedCallBack = (res) => {
    AlertService.showMsg({ message: "Order is accepted" });
    defaulConfirmDialogStateValues();
    getPendingOrders();
  };

  const markAsReadyOrShipped = () => {
    let apiOptions = {
      url: `order/${selectedOrder.id}/MarkAsReadyOrShipped`
    };
    http.put(apiOptions).then(res => {
      markAsReadyOrShippedCallBack(res);
    });
  };

  const markAsReadyOrShippedCallBack = (res) => {
    let successMsg = "";
    if (selectedOrder.orderTypeId === 1) {
      successMsg = "Order shipped";
    }
    else if (selectedOrder.orderTypeId === 2) {
      successMsg = "Order ready";
    }
    AlertService.showMsg({ message: successMsg });
    defaulConfirmDialogStateValues();
    getPendingOrders();
  };

  const markOrderDelivered = () => {
    let inputData = {
      id: selectedOrder.id,
      currentDate: formatService.getCurrentDateForServer()
    }
    let apiOptions = {
      url: `order/MarkOrderDelivered`,
      data: inputData
    };
    http.post(apiOptions).then(res => {
      markOrderDeliveredCallBack(res);
    });
  };

  const markOrderDeliveredCallBack = (res) => {
    AlertService.showMsg({ message: "Order delivered" });
    defaulConfirmDialogStateValues();
    getPendingOrders();
  };

  const openConfirmDialogForCancel = (item) => {
    setSelectedOrder(item);
    setIsCancelAction(true);
    setConfirmOpen(true);
  };

  const cancelOrder = (data) => {
    let inputData = {
      id: selectedOrder.id,
      cancelledRemarks: data.comments,
    }
    
  if (data.cancellationReasonId) {
    inputData.cancellationReasonId = data.cancellationReasonId;
  }
    console.log("irderid",inputData)
    let apiOptions = {
      url: `order/MarkOrderCancelled`,
      data: inputData
    };
    http.post(apiOptions).then(res => {
      cancelOrderCallBack(res);
      AlertService.showMsg({ message: "Success" });
    });
  };

  const cancelOrderCallBack = (res) => {
    defaulConfirmDialogStateValues();
    getPendingOrders();
  };

  const closedeliverySlots = () => {
    setDeliverySlotsOpen(false);
    setOrderId(0);
    setDeliverySlotId(0);
  };

  const closedPickupSlots = ()=>{
    setPickUpSlotsOpen(false);
    setOrderId(0);
    setDeliverySlotId(0);
  }

  const getAvailableSlots = (item) => {
    setOrderId(item.id);
    setDeliverySlotId(item.deliverySlotId);
    let inputData = {
      stallId: item.stallId
    }
    let apiOptions = {
      url: `stalldeliveryslot/available`,
      data: inputData
    };
    http.post(apiOptions).then(res => {
      getAvailableSlotsCallBack(res,item.orderTypeId);
    });
  };

  const getAvailableSlotsCallBack = (res,orderTypeId) => {
    const result = res.data;
    if (result.deliverySlots.length > 0) {
      for (let item of result.deliverySlots) {
        item.startTime = item.startTime != null ? general.getFormattedTime(item.startTime) : null;
        item.endTime = item.endTime != null ? general.getFormattedTime(item.endTime) : null;
      }
      setAvailableSlots(result.deliverySlots);
    }
    else {
      setAvailableSlots([]);
    }

    if(orderTypeId === 1){
      setDeliverySlotsOpen(true);
    }
    else if(orderTypeId === 2){
      setPickUpSlotsOpen(true);
    }
    
  };

  const onSelectSlot = (item) => {
    if (item.id != deliverySlotId) {
      setDeliverySlotId(item.id);
    }
    else {
      setDeliverySlotId(0);
    }
  };

  const changeDeliverySlot = () => {
    let inputData = {
      id: orderId,
      deliverySlotId: deliverySlotId
    };
    let apiOptions = {
      url: `order/updatedeliveryslot`,
      data: inputData
    };
    http.put(apiOptions).then(res => {
      changeDeliverySlotCallBack(res);
    });
  };

  const changeDeliverySlotCallBack = (res) => {
    AlertService.showMsg({ message: "Updated  slot" });
    closedeliverySlots();
    getPendingOrders();
  };

  const navToMessage = (orderId) => {
    setOrderId(orderId);
    setOpenMessage(true);
  }

  const handleMessageClose = () => {
    setOpenMessage(false);
    setOrderId(0);
  }

  useEffect(() => {
    getPendingOrders();
  }, [props.stallId])


  const body = (
    <div className="pendingorders-ui">
      <div className="content-container">
        <div className="content">
          {/* Desktop View */}
          <div className='deskview'>
            <div className='py-2'>
              <b>Pending Item Orders</b>
            </div>
            <div className='my-2'>
              <TableContainer component={Paper} className={classes.root}>
                <Table size="small" className='table-striped'>
                  <TableHead>
                    <TableRow>
                      <TableCell>Date</TableCell>
                      <TableCell>Shop</TableCell>
                      <TableCell>Delivery Type</TableCell>
                      <TableCell>Consumer</TableCell>
                      <TableCell className='text-right'>Order#</TableCell>
                      <TableCell>Status</TableCell>
                      <TableCell className='text-right'>Amount</TableCell>
                      <TableCell>Payment</TableCell>
                      <TableCell className="pl-0">Action</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {orderList.length == 0 &&
                      <TableCell colSpan={9}>
                        <NoRecords />
                      </TableCell>
                    }
                    {orderList.length > 0 && orderList.map((row: any, i) => (
                      <TableRow>
                        <TableCell><FxDateDisplay value={row.orderDate} /></TableCell>
                        <TableCell>{row.stallName}</TableCell>
                        <TableCell>
                          {row.orderTypeId == 1 &&
                            <span>Delivery</span>
                          }
                          {row.orderTypeId == 2 &&
                            <span>Pickup</span>
                          }
                        </TableCell>
                        <TableCell>
                          <div>
                            <span>{row.consumerName}</span>
                            <span className='pl-2'>{row.consumerPhone}</span>
                          </div>
                        </TableCell>
                        <TableCell className='text-right'>#{row.orderIdentifier}</TableCell>
                        <TableCell>
                          {row.orderStatus}
                          {
                            row.orderStatus === 'Cancelled' &&
                            <span className='pl-2'>({row.cancelledRemarks})</span>
                          }
                        </TableCell>
                        <TableCell className='text-right'><FxCurrency value={row.orderTotal} /></TableCell>
                        <TableCell>
                          {row.orderPayments && row.orderPayments.map((itemObj, i) => (
                            <div>
                              {itemObj.paymentMode == 'cod' &&
                                <span className='payment-style'>
                                  Cash / {itemObj.paymentStatus}
                                </span>
                              }
                              {itemObj.paymentMode == 'stripe' &&
                                <span className='payment-style'>
                                  {'Card :' + itemObj.paymentStatus}
                                </span>
                              }
                              {itemObj.paymentMode != 'cod' && itemObj.paymentMode != 'stripe' &&
                                <span className='payment-style'>
                                  {itemObj.paymentMode} / {itemObj.paymentStatus}
                                </span>
                              }
                            </div>
                          ))
                          }
                        </TableCell>
                        <TableCell className="pl-0">
                          <Button variant='outlined' size='small' className='button-style mr-2' onClick={() => viewOrderDetail(row)}>View Order</Button>
                          {
                            row.orderStatusId === 1 &&
                            <Button variant='outlined' size='small' className='button-style' onClick={() => openConfirmDialogByStatus(row)}>Accept</Button>
                          }
                          {
                            (row.orderStatusId === 2 && row.orderTypeId === 1) &&
                            <Button variant='outlined' size='small' className='button-style' onClick={() => openConfirmDialogByStatus(row)}>Ship</Button>
                          }
                          {
                            (row.orderStatusId === 2 && row.orderTypeId === 2) &&
                            <Button variant='outlined' size='small' className='button-style' onClick={() => openConfirmDialogByStatus(row)}>Ready</Button>
                          }
                          {
                            (row.orderStatusId === 4 || row.orderStatusId === 5) &&
                            <Button variant='outlined' size='small' className='button-style' onClick={() => openConfirmDialogByStatus(row)}>Deliver</Button>
                          }
                          {
                            row.orderStatusId === 1 &&
                            <Button variant='outlined' size='small' className='button-style ml-2' onClick={() => openConfirmDialogForCancel(row)}>Cancel</Button>
                          }

                          <Button variant='outlined' size='small' className='button-style ml-2' onClick={() => navToMessage(row.id)}>Direct</Button>
                          <div className='pt-2'>
                            {
                              row.orderStatusId !== 7 &&
                              <Button variant='outlined' size='small' className='button-style' onClick={() => getAvailableSlots(row)}>Change Slot</Button>
                            }
                          </div>
                        </TableCell>

                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </div>
        </div>
      </div>
      <div>
        <Dialog
          open={open}
          maxWidth="md"
          fullWidth
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description">
          <ProviderItemOrderDetail orderId={orderId} handleClose={handleClose} />
        </Dialog>
      </div>
      <div>
        <Dialog
          open={confirmOpen}
          maxWidth="sm"
          fullWidth
          onClose={handleDialogClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description">
          <ConfirmDialog message={message} handleDialogClose={handleDialogClose} onConfirmCallback={onConfirmCallback} action={isCancelAction ? "cancel" : ""} />
        </Dialog>
      </div>
      <div>
        <Dialog
          open={deliverySlotsOpen}
          maxWidth="md"
          fullWidth
          onClose={closedeliverySlots}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description">
          <DeliverySlots
            handleClose={closedeliverySlots}
            availableSlots={availableSlots}
            deliverySlotId={deliverySlotId}
            onSelectSlot={onSelectSlot}
            isSave={true}
            isDay={true}
            saveDeliverySlot={changeDeliverySlot}
          />
        </Dialog>
        <Dialog
          open={pickupSlotsOpen}
          maxWidth="md"
          fullWidth
          onClose={closedPickupSlots}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description">
          <PickUpSlots
            handleClose={closedPickupSlots}
            availableSlots={availableSlots}
            deliverySlotId={deliverySlotId}
            onSelectSlot={onSelectSlot}
            isSave={true}
                        isDay={true}

            saveDeliverySlot={changeDeliverySlot}
          />
        </Dialog>
        <Drawer anchor={"right"} classes={{ paper: classes.drawerWidth }} open={openMessage} onClose={toggleDrawerMessage}>
          <MessageContainer orderId={orderId} handleMessageClose={handleMessageClose} />
        </Drawer>
      </div>
    </div>
  );

  return (
    <div>{body}</div>
  );

}

export default PendingOrders;